module.exports = __webpack_public_path__ + "static/media/car_bg.0ce31b77.svg";